module.exports = __webpack_public_path__ + "img/6.138f3635.jpg";